<template>
    <div>
        <div class="start" v-if="bannerData.length">
        <div v-for="(item, index) in bannerData" :key="index" class="start-item">
            <div>
                <img :src="item.image_url" class="start-item__image">
                <div class="start-item__content">
                    <div class="start-item__button"
                        :class="index == 0 ? 'start-item__button__left' : 'start-item__button__right'"
                        @click="toPage(item.link_url)">
                        <img v-if="index == 0" src="@/assets/common/icon_start_left.png" srcset="@/assets/common/icon_start_left@2x.png 2x" class="icon" />
                        <img v-if="index == 1" src="@/assets/common/icon_start_right.png" srcset="@/assets/common/icon_start_right@2x.png 2x" class="icon"/>
                        {{ item.button }}
                    </div>
                    <div class="start-item__title">{{ item.title }}</div>
                    <div class="start-item__summary">{{ item.summary }}</div>
                </div>
            </div>
        </div>
        </div>
        <p class="copyright">{{ lang.copyright }}</p>
    </div>
</template>
<script setup>
    import { onMounted, ref } from 'vue';
    import { ConfigGetAPI } from '@/api/common.js';

     // 语言包
    const language = localStorage.getItem("language") || "zh"
    const lang = ref({})
    import(`@/language/${language}.js`).then(data => {
        lang.value = data.default.footer
    }) 

    // 参数
    const bannerParam = ref({ name: "start_page" })

    // banner数据
    const bannerData = ref([])
    
    // banner获取
    const getBannerList = () =>{
        ConfigGetAPI(bannerParam.value).then(res=>{
            bannerData.value = res.list
        });
    }

    onMounted(() => {
        getBannerList()
    });

    // 跳转页面
    const toPage = (link) => {
        window.location.href = link
    }

</script>

<style lang="scss" scoped>
    .start{
        display: flex;
        width: 100%;
          
        &-item {   
            min-width: 960px;
            width: 50%;
            position: relative;

            &__content {
                position: absolute;
                top: 60vh;
                padding: 0 66px;
            }

            &__button {
                width: fit-content;
                padding: 0 36px;
                height: 60px;
                line-height: 60px;
                text-align: center;
                color: #FFFFFF;
                border-radius: 30px;
                background-color: rgba(255, 255, 255, 0.6);
                cursor: pointer;
                font-family: PingFangSC-medium;
                font-weight: 500;
                font-size: 23px;
                display: flex;
                justify-content: center;
                align-items: center;
                margin-bottom: 11px;

                .icon {
                    margin-right: 11px;
                }
            }

            &__button__left {
                color: #059669;
            }

            &__button__right {
                color: #001AAA;
            }

            &__button:hover{
                opacity: .75;
            }

            &__title {
                font-family: PingFangSC-medium;
                color: #FFFFFF;
                font-weight: 500;
                font-size: 48px;
                margin-bottom: 18px;
                opacity: .8;
                line-height: 67px;
            }

            &__summary {
                color: #FFFFFF;
                font-weight: 400;
                font-size: 30px;
            }

            &__image {
                width: 100%;
                object-fit: cover;
                min-width: 960px;
            }
        }   
    }

    .copyright{
          color: #999999;
          font-weight: 400;
          font-size: 18px;
          text-align: center;
    }
/* 响应式布局 */
@media (max-width: 768px) {
    .start{
        display: block;
        width: 100%;

        &-item {   
            min-width: 100%;
            width: 100%;

            &__content {
                position: absolute;
                top: 50%;
                padding: 0 24px;
            }

            &__button {
                padding: 0 18px;
                height: 40px;
                line-height: 40px;
                border-radius: 20px;
                font-size: 17px;
                margin-bottom: 11px;

                .icon {
                    margin-right: 5px;
                }
            }

            &__title {
                font-size: 24px;
                margin-bottom: 9px;
                line-height: 34px;
            }

            &__summary {
                font-size: 15px;
            }

            &__image {
                min-width: 100%;
                width: 100%;
            }
        }   
    }
    .copyright {
        font-family: Inter-regular;
        color: #999999;
        font-weight: 400;            
        font-size: 12px;
        padding-bottom: 38px;
    }
}

</style>    